import { InjectionToken } from '@angular/core';

import { MiddlewareSDK, MiddlewareStore } from './middleware-sdk.types';

export const SDK = new InjectionToken<MiddlewareSDK>('eep.sdk');
export const STORE = new InjectionToken<MiddlewareStore>('eep.store');
